import React from 'react';
import { Navigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import useMobxStoreHook from "../hooks/use-mobx-store.hook";

const RequireAuth = observer(({ children }) => {

    const {
        session: { isAuthenticated },
    } = useMobxStoreHook();

    if (!isAuthenticated) {
      return <Navigate to="/login" replace />;
    }

    return children;
});

export default RequireAuth;
